import articlesImage from "../../assets/images/articles.jpg";
import forBusinessesCOVIDImage from "../../assets/images/covid.jpg";
import employerImage from "../../assets/images/employers.jpg";
import healthplansImage from "../../assets/images/healthplans.jpg";
import scienceImage from "../../assets/images/science.jpg";
export var topLevelLinks = function topLevelLinks() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return {
    telehealth: {
      label: "Telehealth"
    },
    shop: {
      label: "Shop"
    },
    learn: {
      label: "Learn"
    },
    business: {
      label: "For Businesses"
    },
    register: {
      label: "Register kit",
      url: "".concat(e, "/register")
    },
    support: {
      label: "Support",
      url: "https://support.everlywell.com/",
      mobileSubcategoryLabel: "Help"
    },
    login: {
      label: "Log in",
      url: "".concat(e, "/login")
    },
    logout: {
      label: "Log Out",
      url: "https://secure.everlywell.com/logout/"
    },
    shopAll: {
      label: "Shop All",
      url: "".concat(e, "/products/")
    },
    giftCards: {
      label: "Gift Cards",
      url: "".concat(e, "/gift-cards/")
    }
  };
};
export var _topLevelLinks = function _topLevelLinks() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return {
    telehealth: {
      label: "Telehealth"
    },
    shop: {
      label: "Shop"
    },
    learn: {
      label: "Learn"
    },
    business: {
      label: "For Businesses"
    },
    register: {
      label: "Register kit",
      url: "".concat(e, "/register/")
    },
    support: {
      label: "Support",
      url: "https://support.everlywell.com/",
      mobileSubcategoryLabel: "Help"
    },
    shopAll: {
      label: "Shop All",
      url: "".concat(e, "/products/")
    },
    giftCards: {
      label: "Gift Cards",
      url: "".concat(e, "/gift-cards/")
    }
  };
};
export var _accountLinks = {
  login: {
    label: "Login",
    url: "https://secure.everlywell.com/login"
  },
  account: {
    label: "My Everly",
    hub: {
      label: "My Everly",
      url: "https://results.everlywell.com/dashboard/"
    },
    logout: {
      label: "Log Out",
      url: "https://secure.everlywell.com/logout/"
    },
    membership: {
      label: "My Membership"
    }
  }
};
export var shopCategories = function shopCategories() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return {
    "General Wellness": "".concat(e, "/products/?category=3"),
    "Men's Health": "".concat(e, "/products/?category=5"),
    "Women's Health": "".concat(e, "/products/?category=6"),
    "Energy + Weight": "".concat(e, "/products/?category=4"),
    "Sexual Health": "".concat(e, "/products/?category=8"),
    "COVID-19": "".concat(e, "/products/covid-19-test/")
  };
};
export var forBusinessesCategories = function forBusinessesCategories() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var l = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  return {
    "For Employers": {
      url: "".concat(l, "/employers/"),
      imageSrc: employerImage,
      imageAlt: "Employers"
    },
    "For Healthplans": {
      url: "".concat(l, "/health-plans/"),
      imageSrc: healthplansImage,
      imageAlt: "Healthplans"
    },
    "For COVID-19 Tests": {
      url: "".concat(e, "/business/covid-19/"),
      imageSrc: forBusinessesCOVIDImage,
      imageAlt: "Businesses - COVID-19"
    }
  };
};
export var learnCategories = function learnCategories() {
  var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  return {
    "The Science": {
      url: "".concat(e, "/science/"),
      imageSrc: scienceImage,
      imageAlt: "Science"
    },
    Articles: {
      url: "".concat(e, "/blog/"),
      imageSrc: articlesImage,
      imageAlt: "Articles"
    }
  };
};
export var accountLinks = {
  hub: {
    label: "My Everly",
    url: "https://results.everlywell.com/dashboard/"
  },
  logout: {
    label: "Log Out",
    url: "https://secure.everlywell.com/logout/"
  },
  membership: {
    label: "My Membership"
  }
};